import { connect } from 'react-redux';

import {
  CloneModalDialog,
  CloneProtocol,
} from '@atlassian/bitkit-clone-controls';

import { uncurlyUuid } from 'src/components/analytics';
import {
  getCurrentRepository,
  getRepositorySourceTreeHasXcode,
} from 'src/selectors/repository-selectors';
import {
  getCurrentUser,
  getCurrentUserDefaultCloneProtocol,
} from 'src/selectors/user-selectors';
import { BucketState, BucketDispatch } from 'src/types/state';
import { publishUiEvent } from 'src/utils/analytics/publish';

import toggleCloneDialog from '../actions/toggle-clone-dialog';
import MirrorCloneControls from '../containers/mirror-clone-controls';

type CloneModalDialogProps = {
  defaultProtocol: CloneProtocol;
  isOpen: boolean;
  repository?: BB.Repository;
  user?: BB.User;
  xcode: boolean;
};

const mapStateToProps = (state: BucketState) => {
  const user = getCurrentUser(state);
  return {
    defaultProtocol: getCurrentUserDefaultCloneProtocol(state),
    isOpen: state.repository.section.isCloneDialogOpen,
    repository: getCurrentRepository(state),
    user,
    xcode: getRepositorySourceTreeHasXcode(state),
  };
};

const mapDispatchToProps = (dispatch: BucketDispatch) => ({
  onDialogDismissed: () => dispatch(toggleCloneDialog(false)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)((props: CloneModalDialogProps) => {
  return (
    <CloneModalDialog
      {...props}
      onCloneClient={(client: 'Sourcetree' | 'Xcode' | 'VSCode') => {
        publishUiEvent({
          action: 'clicked',
          actionSubject: 'button',
          actionSubjectId: 'repositoryCloneButton',
          objectType: 'repository',
          objectId: props.repository ? uncurlyUuid(props.repository.uuid) : '',
          containerType: 'workspace',
          containerId: props.repository?.workspace
            ? uncurlyUuid(props.repository.workspace.uuid)
            : '',
          source: 'repositoryCloneModal',
          attributes: {
            client,
          },
        });
      }}
    >
      <MirrorCloneControls protocol={props.defaultProtocol} {...props} />
    </CloneModalDialog>
  );
});
